const MAX_KEPT = 80;
const logs = [];
const listeners = new Set();
function notify() {
    listeners.forEach((fn) => fn());
}
export const debugLogs = {
    push(log) {
        logs.push(log);
        if (logs.length > MAX_KEPT)
            logs.splice(0, logs.length - MAX_KEPT);
        notify();
    },
    subscribe(fn) {
        listeners.add(fn);
        return () => listeners.delete(fn);
    },
    getAll() {
        return logs;
    },
    clear() {
        logs.length = 0;
        notify();
    },
};
